import { formatCurrency } from "@/helpers/currency-formatter";
import type { LastPurchaseSummary } from "@/types";
import { formatDateAR } from "@/utils/date";

interface LastPurchaseInfoProps {
  requestItemId: number;
  requestItemDescription: string;
  hasProductAssigned: boolean;
  lastPurchase?: LastPurchaseSummary;
  onOpenHistory?: (requestItemId: number, requestItemDescription: string) => void;
  className?: string;
}

export default function LastPurchaseInfo({
  requestItemId,
  requestItemDescription,
  hasProductAssigned,
  lastPurchase,
  onOpenHistory,
  className,
}: LastPurchaseInfoProps) {
  const containerClass = className ?? "text-xs text-muted-foreground";

  if (!hasProductAssigned) {
    return (
      <div className={containerClass}>
        <div className="flex items-center gap-2">
          <span>Asigna un producto para ver historial</span>
          <button
            type="button"
            className="text-blue-600 hover:underline"
            onClick={() => onOpenHistory?.(requestItemId, requestItemDescription)}
          >
            Ver historial
          </button>
        </div>
      </div>
    );
  }

  if (!lastPurchase) {
    return (
      <div className={containerClass}>
        <div className="flex items-center gap-2">
          <span>Sin compras previas</span>
          <button
            type="button"
            className="text-blue-600 hover:underline"
            onClick={() => onOpenHistory?.(requestItemId, requestItemDescription)}
          >
            Ver historial
          </button>
        </div>
      </div>
    );
  }

  const dateStr = lastPurchase.created_at ? formatDateAR(lastPurchase.created_at) : "";
  const amountStr = typeof lastPurchase.unit_price_ars === "number" && lastPurchase.unit_price_ars > 0
    ? formatCurrency(lastPurchase.unit_price_ars, "ARS")
    : formatCurrency(lastPurchase.unit_price, lastPurchase.currency || "ARS");

  return (
    <div className={containerClass}>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span>
          Última compra: {amountStr} — {lastPurchase.supplier_name} — {dateStr}
        </span>
        <button
          type="button"
          className="text-blue-600 hover:underline"
          onClick={() => onOpenHistory?.(requestItemId, requestItemDescription)}
        >
          Ver historial
        </button>
      </div>
    </div>
  );
}
